<script>
  import { blocklist, text, richtext, image, url } from "../toolbox.js";
  import { link, links } from "svelte-routing";

  export let block;
</script>

<section id="faq" class="faq">

  <div class="container" data-aos="fade-up">

    <header class="section-header">
      <h2>{text(block, 'preheadline')}</h2>
      <p>{text(block, 'headline')}</p>
    </header>

    <div class="row">
      <div class="col-lg-6">
        <!-- F.A.Q List 1-->
        <div class="accordion accordion-flush" id="faqlist1">
          {#each blocklist(block, 'left') as item, i}
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq-content-{i}">
                {text(item, 'question')}
              </button>
            </h2>
            <div id="faq-content-{i}" class="accordion-collapse collapse" data-bs-parent="#faqlist1">
              <div class="accordion-body">
                {@html richtext(item, 'answer')}
              </div>
            </div>
          </div>
          {/each}
        </div>
      </div>

      <div class="col-lg-6">
        <!-- F.A.Q List 2-->
        <div class="accordion accordion-flush" id="faqlist2">
          {#each blocklist(block, 'right') as item, i}
          <div class="accordion-item">
            <h2 class="accordion-header">
              <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#faq2-content-{i}">
                {text(item, 'question')}
              </button>
            </h2>
            <div id="faq2-content-{i}" class="accordion-collapse collapse" data-bs-parent="#faqlist2">
              <div class="accordion-body">
                {@html richtext(item, 'answer')}
              </div>
            </div>
          </div>
          {/each}
        </div>
      </div>

    </div>

  </div>

</section>
